module.exports = __webpack_public_path__ + "img/Logo-generations-futures.177d67e5.png";